import React from 'react';
import { CitedText, SourceList } from './InsightsPanel';

/**
 * The coach's review of a finished workout: praise grounded in the numbers, what to focus
 * on next time, per-exercise cues, and the sources behind any guideline it relies on.
 * Shared by the post-workout summary and History.
 */
function CoachReview({ t, session, loading, compact = false }) {
  const cues = (session.exerciseNotes || []).filter(n => n.coachCue);
  const sources = session.coachSources || [];
  const hasReview = !!session.coachPraise;

  if (!hasReview && !loading) return null;

  return (
    <section className={`st-review ${compact ? 'compact' : ''}`} aria-live="polite">
      <div className="st-review-head">
        <h3>🧭 {t('strength.review.title')}</h3>
        {hasReview && (
          <span className="st-muted st-small">
            {session.coachReviewByAi ? t('strength.review.byAi') : t('strength.review.byRules')}
          </span>
        )}
      </div>

      {!hasReview && loading && <p className="st-muted">{t('strength.review.reviewing')}</p>}

      {hasReview && (
        <>
          <p className="st-review-praise"><CitedText text={session.coachPraise} evidence={sources} /></p>
          {session.coachFocus?.length > 0 && (
            <>
              <h4>🎯 {t('strength.review.focusNext')}</h4>
              <ul className="st-review-focus">
                {session.coachFocus.map((item, i) => <li key={i}><CitedText text={item} evidence={sources} /></li>)}
              </ul>
            </>
          )}
          {!compact && cues.length > 0 && (
            <ul className="st-review-cues">
              {cues.map(n => (
                <li key={n.exerciseKey}>
                  <strong>{n.exerciseName}</strong>
                  {n.adjustment !== 'None' && <span className={`st-badge st-adjust-${n.adjustment}`}>{t(`strength.review.adjustment.${n.adjustment}`)}</span>}
                  <span> <CitedText text={n.coachCue} evidence={sources} /></span>
                </li>
              ))}
            </ul>
          )}
          {loading && <p className="st-muted st-small">{t('strength.review.refining')}</p>}
          <SourceList t={t} evidence={sources} />
        </>
      )}
    </section>
  );
}

export default CoachReview;
